import { useTracking } from '@packages/tracking';

export const useServiceLayerTracking = () => {
  const dispatchTracking = useTracking();

  // SERVICE_LAYER
  const trackServiceLayerClick = (serviceLayerID: string) => {
    dispatchTracking({
      event: 'ga_event',
      eventAction: 'click',
      eventCategory: 'service_layer',
      eventValue: serviceLayerID,
    });
  };

  return {
    trackServiceLayerClick,
  };
};
